import React, { useState } from 'react';
import styled from 'styled-components';
import {
  collabData,
  decorData,
  inspirationData,
  newData,
  outdoorData,
  swatchesData,
  furnitureData,
} from '../../../common/helper';
import MenuList from './MenuList';
import MenuListDetails from './MenuListDetails';

const Wrapper = styled.div``;

function MenuItemWrapper() {
  const [selected, setSelected] = useState(null);

  const resetSelected = () => {
    setSelected(null);
  };

  const getData = () => {
    switch (selected) {
      case 'bedroom':
        return { name: 'Bedroom', details: bedroomData };
      case 'living':
        return { name: 'Living', details: livingRoomData };
      case 'dining':
        return { name: 'Dining', details: diningRoom };
      case 'office':
        return { name: 'Office', details: officeData };
      case 'decor':
        return { name: 'Decor', details: decorData };
      case 'outdoor':
        return { name: 'Outdoor', details: outdoorData };
      case 'new':
        return { name: 'New', details: newData };
      case 'inspiration':
        return { name: 'Inspiration', details: inspirationData };
      case 'collaborations':
        return { name: 'Collaborations', details: collabData };
      case 'swatches':
        return { name: 'Swatches', details: swatchesData };
      case 'gifts':
        return { name: 'Gifts', details: giftsData };
      case 'furniture':
        return { name: 'Furniture', details: furnitureData };
      default:
        return null;
    }
  };

  const data = getData();

  return (
    <Wrapper>
      {data ? (
        <MenuListDetails
          className="mobile-menu"
          name={data.name}
          data={data.details}
          resetSelected={resetSelected}
        />
      ) : (
        <MenuList setSelected={setSelected} className="mobile-menu" />
      )}
    </Wrapper>
  );
}

export default MenuItemWrapper;
